import React, { FC, ReactNode } from 'react';
import SVGInline from 'components/SVGInline/SVGInline';
import { CardBottomGradient, ContentMarker, ContentMarkerIcon } from 'style/styled-components/reusable.css';
import { Marker } from 'types/Asset';
import { hasProgressBar } from 'utils/fnData';

type PropTypes = {
    progressBar?: ReactNode;
    contentMarker?: Marker;
    showProgress?: boolean;
};

export const CardOverlays: FC<PropTypes> = ({ progressBar, contentMarker, showProgress = true }) => {
    const withProgressBar = showProgress && hasProgressBar(progressBar);

    return (
        <>
            {withProgressBar && <CardBottomGradient aria-hidden={true} />}
            {showProgress && progressBar}
            {contentMarker != null && (
                <ContentMarker withProgressBar={withProgressBar} marker={contentMarker}>
                    {contentMarker.icon && (
                        <ContentMarkerIcon>
                            <SVGInline svg={contentMarker.icon} />
                        </ContentMarkerIcon>
                    )}
                    <span>{contentMarker.value}</span>
                </ContentMarker>
            )}
        </>
    );
};
